import apiClient from './axiosClient';

export const paymentApi = {
  getPayments: (params) =>
    apiClient.get('/payments', { params }),
  // params: { status, page, pageSize }

  getPaymentDetail: (id) =>
    apiClient.get(`/payments/${id}`),
};
